import React, { Component } from 'react'
import './handf.css'
import { withRouter } from 'react-router-dom'

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount = function () {
    document.onclick = this.AllClick.bind(this) //下拉菜单监听隐藏
  }

  AllClick = () => {
    this.setState({
      // FootToggleOn: true,
      // FootDisplay:'none',
    })
  }

  componentWillUnmount = () => {
    this.setState = () => {}
  }

  render() {
    return (
      <div className={'Footer'}>
        <div className={'FooterBox'}>
          <div className={'FooterLogo'}>
            <img
              src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
              alt=""
            />
          </div>
          <div className={'FooterMain clearfix'}>
            <div className={'FooterMainWB'}>
              <div className={'FooterMainW'}>指导单位</div>
              <div className={'FooterMainW'}>中国民用航空局</div>
              <div className={'FooterMainW'}>空军招飞局</div>
            </div>
            <div className={'FooterMainBor'}> </div>
            <div className={'FooterMainWB'} style={{ width: 388 }}>
              <div className={'FooterMainW'}>主办单位</div>
              <div className={'FooterMainW'}>
                国家体育总局航空无线电模型运动管理中心
              </div>
              <div className={'FooterMainW'}>中国航空运动协会</div>
            </div>
            <div className={'FooterMainBor'}> </div>
            <div className={'FooterMainWB'}>
              <div className={'FooterMainW'}>模拟飞行服务平台</div>
              <div className={'FooterMainW'}>
                技术支持：北京鹰扬科技有限公司
              </div>
              <div className={'FooterMainW'}>投诉建议：cjfsc@asfcyy.com</div>
            </div>
            <div className={'FooterCode'}>
              <img
                src="http://oss.asfcyy.com/richTextImage/237d60d0bc9211ec9dc800163e3521a2.jpg"
                alt=""
              />
            </div>
          </div>
          <div className={'FB'}> </div>
          <div className={'FBWB clearfix'}>
            <div className={'FBW'}>不作为中小学生入学依据</div>
            <div className={'FBW'} style={{ float: 'right', fontSize: 12 }}>
              全国青少年模拟飞行锦标赛 （教监管厅函[2022]13号）
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Footer)
